import { drawing, geometry } from '@progress/kendo-drawing';
import { AutoSizeableMixin } from './AutoSizeableMixin.js';
import { VisualBase } from './VisualBase.js';
import { deepExtend } from '../utils/deep-extend.js';
import { defined, isNumber } from '../utils/functions.js';

const textColor = (options) => {
    if (options && options.color) {
        options = deepExtend({}, options, {
            fill: {
                color: options.color
            }
        });
    }
    return options;
};
const defaultOptions = {
    fontSize: 15,
    fontFamily: 'sans-serif',
    stroke: {
        width: 0
    },
    fill: {
        color: 'black'
    },
    autoSize: true
};
class TextBlock extends VisualBase {
    constructor(options) {
        options = deepExtend({}, defaultOptions, options);
        options = textColor(options);
        super(options);
        this._setScale = AutoSizeableMixin._setScale.bind(this);
        this._setTranslate = AutoSizeableMixin._setTranslate.bind(this);
        this._initSize = AutoSizeableMixin._initSize.bind(this);
        this._updateSize = AutoSizeableMixin._updateSize.bind(this);
        this._font();
        this._initText();
        this._initSize();
    }
    _initText() {
        const options = this.options;
        this.drawingElement = new drawing.Text(defined(options.text) ? options.text : '', new geometry.Point(), {
            font: options.font
        });
        this._fill();
        this._stroke();
    }
    _font() {
        const options = this.options;
        if (options.fontFamily && defined(options.fontSize)) {
            const fontOptions = [];
            if (options.fontStyle) {
                fontOptions.push(options.fontStyle);
            }
            if (options.fontWeight) {
                fontOptions.push(options.fontWeight);
            }
            fontOptions.push(options.fontSize + (isNumber(options.fontSize) ? 'px' : ''));
            fontOptions.push(options.fontFamily);
            options.font = fontOptions.join(' ');
        }
        else {
            delete options.font;
        }
    }
    content(text) {
        return this.drawingElement.content(text);
    }
    redraw(options) {
        if (options) {
            let sizeChanged = false;
            const textOptions = this.options;
            options = textColor(options);
            super.redraw(options);
            if (options.fontFamily || defined(options.fontSize) || options.fontStyle || options.fontWeight) {
                deepExtend(textOptions, {
                    fontFamily: options.fontFamily,
                    fontSize: options.fontSize,
                    fontStyle: options.fontStyle,
                    fontWeight: options.fontWeight
                });
                this._font();
                this.drawingElement.options.set('font', textOptions.font);
                sizeChanged = true;
            }
            if (options.text) {
                this.content(options.text);
                sizeChanged = true;
            }
            if (!this._updateSize(options) && sizeChanged) {
                this._initSize();
            }
        }
    }
}

export { TextBlock };
